import { intl } from '@helpers/intl';
import { makeTroubleshootRoute } from '@models/Filing/aggregatesSummary/helpers/makeTroubleshootRoute';

import { buildRow } from './helpers/buildRow';

export const aggregatesSummaryModel = (
  aggregates,
  countryIso,
  filingPeriodId,
  disableOnlineTroubleshoot
) => {
  const makeRoute = makeTroubleshootRoute(countryIso, filingPeriodId, disableOnlineTroubleshoot);
  const inputRows = aggregates?.results
    ?.filter(aggregate => aggregate?.inputOutput === 'input')
    .map(item => buildRow(item, makeRoute));
  const outputRows = aggregates?.results
    ?.filter(aggregate => aggregate?.inputOutput === 'output')
    .map(item => buildRow(item, makeRoute));
  const blankRows = aggregates?.results
    ?.filter(aggregate => aggregate?.blankAggregate)
    .map(item => buildRow(item, makeRoute));

  return {
    sections: [
      ...(outputRows?.length
        ? [
            {
              title: intl.formatMessage({
                id: 'components.summary-table.transaction.output',
                defaultMessage: 'Output transaction types',
              }),
              rows: outputRows,
            },
          ]
        : []),
      ...(inputRows?.length
        ? [
            {
              title: intl.formatMessage({
                id: 'components.summary-table.transaction.input',
                defaultMessage: 'Input transaction types',
              }),
              rows: inputRows,
            },
          ]
        : []),
      ...(blankRows?.length
        ? [
            {
              title: intl.formatMessage({
                id: 'components.summary-table.transaction.blank',
                defaultMessage: 'Missing transaction types',
              }),
              rows: blankRows,
            },
          ]
        : []),
    ],
    totals: {
      totalVat: aggregates?.standardTemplateLevel?.totalVat,
      totalNet: aggregates?.standardTemplateLevel?.totalNet,
      transactionCount: aggregates?.standardTemplateLevel?.totalRows,
    },
    noTransactionData: !aggregates?.results?.length,
    isDataProcessingAggregate:
      !!aggregates?.results?.[0]?.standardTemplate?.isDataProcessingAggregate, // None of the other isDataProcessingAggregate fields in the standard template slice are reliable.
  };
};
